/**
 * Brand identity used on guest-facing pages (invitations, questionnaires,
 * seat finder). Kept here so the public name and site are defined once rather
 * than retyped into every public surface.
 */
/** Display name shown to guests in page footers and signatures. */
export const BRAND_NAME = 'NP Events & Production';
/** Public marketing site — where a guest-facing footer link points. */
export const PUBLIC_SITE_URL = 'https://np-productions.com';
/** Bundled app logo (served from the frontend's public/ directory). */
export const BRAND_LOGO_PATH = '/logo.png';
//# sourceMappingURL=brand.js.map